<template>
  <div class="game-container" id="game-container">
    <div class="box" v-html="text" @click="resetCheckStatus"></div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'mp-choose-answer16',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      text: '',
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.startData = this.startGameConfig;
      const letters = this.startData.txt.split('');
      this.text = '';
      var br = '&nbsp;';
      for (let i = 0; i < letters.length; i++) {
        if (letters[i] == '<') {
          if (letters[i + 1] == 'b') {
            this.startData.loadTxt += br;
            i += 4;
          } else if (!isNaN(parseInt(letters[i + 1]))) {
            let indx = parseInt(letters[i + 1]);
            this.startData.lists[indx].ans = this.shuffle(this.startData.lists[indx].ans);
            this.text +=
              '<span class="selListWrap"><select class="selList" name="a-' + indx + '"><option value="-1"></option>';
            var self = this;
            this.startData.lists[indx].ans.forEach(function (a, j) {
              self.text += '<option value="' + a + '">' + self.startData.answers[a] + '</option>';
            });
            this.text += '</select></span>';
            i += 3;
          }
        }
        if (i > letters.length) break;
        this.text += letters[i];
      }
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    resetGameAction() {
      var self = this;
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;
      let x = document.getElementsByTagName('select');
      for (let i = 0; i < x.length; i++) {
        if (x[i].options[x[i].selectedIndex].value != self.startData.lists[i].cor) {
          isCorrect = false;
        } else {
          x[i].setAttribute('disabled', true);
        }
      }
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss">
.selList:disabled {
  cursor: not-allowed;
  background-color: #17a2b8;
  color: black;
}
.selListWrap {
  overflow: hidden;
  position: relative;
  display: inline-block;
  top: 15px;
}
.selListWrap:after {
  content: '▼';
  padding: 12px 8px;
  position: absolute;
  right: 8px;
  top: 2px;
  z-index: 1;
  text-align: center;
  width: 10%;
  height: 50%;
  font-size: 25px;
  pointer-events: none;
}
.selList {
  height: 100%;
  width: 100%;
  cursor: pointer;
  padding: 0 20px;
}
</style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 155px;
  padding-left: 90px;
  padding-right: 90px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.box {
  background-repeat: no-repeat;
  position: relative;
  margin: auto;
  display: block;
  text-align: justify;
}
</style>
